// extracted by mini-css-extract-plugin
export default {"addressCard":"AddressCard_addressCard__g4VdM","options":"AddressCard_options__5-mKI","remove":"AddressCard_remove__bB1jl","edit":"AddressCard_edit__ito52"};